import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { User } from '@/api/users';
import { ROLES_LABELS } from '@/utils/constants';
import { sortByString } from '@/utils/table-sort';

import { Table } from '@/components/ui/table';

type UsersTableProps = {
  users: User[];
  onRowClick: (user: User) => void;
};

export function UsersTable({ users, onRowClick }: UsersTableProps) {
  const { t } = useTranslation();

  const getRoleLabel = (role?: string) => {
    if (!role) return '-';
    const roleObj = ROLES_LABELS.find((r) => Object.keys(r)[0] === role);
    return roleObj ? Object.values(roleObj)[0] : role;
  };

  const usersTableHeaders = useMemo(
    () => [
      {
        key: 'user_email',
        label: t('admin-users-table-email'),
        format: (value: unknown) => (value as string) || '-',
        sortFn: sortByString('user_email'),
      },
      {
        key: 'full_name',
        label: t('admin-users-table-name'),
        format: (value: unknown) => (value as string) || '-',
        sortFn: sortByString('full_name'),
      },
      {
        key: 'role',
        label: t('admin-users-table-role'),
        format: (value: unknown) => getRoleLabel(value as string),
      },
      {
        key: 'clinic_name',
        label: t('admin-users-table-clinic'),
        format: (value: unknown) => (value as string) || '-',
        sortFn: sortByString('clinic_name'),
      },
    ],
    [t]
  );

  return <Table headers={usersTableHeaders} data={users} onRowClick={onRowClick} />;
}
